import React from 'react';
import { LayoutContent } from 'components';
import styled from '@emotion/styled';
import { isDJ } from 'utils';

export const ProgressBar = ({ percentage = 0 }) => {
  const ProgressBarContainer = styled.progress`
    ${props => `
      width: 100%;
      height: 10px;
      appearance: none;
      border: none;
      border-radius: 5px;
      overflow: hidden;

      &::-webkit-progress-value {
        background-color: ${props.theme?.progressBarColor};
        border-radius: 5px;
      }
      &::-webkit-progress-bar {
        background-color: ${props.theme?.colors?.grey?.t05};
        border-radius: 5px;
      }
    `}
  `;

  const TopLabelContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-bottom: 5px;
  `;

  const ProgressBarLabel = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: ${isDJ() ? 'black' : '#0B2374'};
    font-family: Latitude Sans;
  `;

  return (
    <LayoutContent rowsGap="3">
      {percentage === 50 && <ProgressBarLabel>You’re halfway there, great work!</ProgressBarLabel>}
      <ProgressBarContainer value={percentage} max={100} />
      <TopLabelContainer>
        <ProgressBarLabel>Application progress</ProgressBarLabel>
        <ProgressBarLabel>{percentage}%</ProgressBarLabel>
      </TopLabelContainer>
    </LayoutContent>
  );
};
